import React from "react";
export default function TablerowAdjButtons({
  idx,
  rowAdd,
  rowUp,
  rowRemove,
  rowDown,
}) {
  return (
    <React.Fragment>
      <div className="text-nowrap">
        <i
          title="Добавить строку ниже"
          onClick={() => rowAdd(idx + 1)}
          className="fa fa-plus cursor-pointer text-hover-primary ml-0"
        ></i>
        <i
          title="Выше"
          onClick={() => rowUp(idx)}
          className="fa fa-level-up cursor-pointer text-hover-primary  ml-2"
        ></i>
      </div>
      <div className="text-nowrap">
        <i
          title="Удалить строку"
          onClick={() => rowRemove(idx)}
          className="fa fa-times cursor-pointer text-hover-danger ml-0"
        ></i>
        <i
          title="Ниже"
          onClick={() => rowDown(idx)}
          className="fa fa-level-down cursor-pointer text-hover-primary ml-2"
        ></i>
      </div>
    </React.Fragment>
  );
}
